import { useEffect } from 'react';

const ChatbaseWidget = () => {
  useEffect(() => {
    // Set chatbot config
    window.embeddedChatbotConfig = {
      chatbotId: "cQyWczCTGYEwKEwSi2lIt",
      domain: "www.chatbase.co"
    };

    // Create and append the script
    const script = document.createElement('script');
    script.src = "https://www.chatbase.co/embed.min.js";
    script.setAttribute('chatbotId', 'cQyWczCTGYEwKEwSi2lIt');
    script.setAttribute('domain', 'www.chatbase.co');
    script.defer = true;
    document.body.appendChild(script);

    // Cleanup on unmount
    return () => {
      const existingScript = document.querySelector('script[src="https://www.chatbase.co/embed.min.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return null;
};

export default ChatbaseWidget;
